import {
  Home, Building, FileUp, LogOut, UserPlus2, PiggyBank, Trophy, MessageCircleQuestionIcon,
  NotebookIcon, FolderPlus, FolderKey, Construction, PencilRuler, Wallet, FileSpreadsheet, FileChartColumn, FileChartColumnIncreasing, Gauge,
  UserCheck,
  UserSearch
} from 'lucide-react';
import '../../styles/components/_sidebar.scss';
import Logo from '../../assets/images/homecorp-logo.png';
import LogoSM from '../../assets/images/homecorp-logo-small.png';
import User from '../../assets/images/avatar2.png';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ViabilitySpreadsheet from '../ViabilitySpreadsheet';
import DocsEnterprises from '../DocsEnterprises';
import DocsIncorporadores from '../DocsIncorporadores';
import { AxiosHttp } from '../../http/axios';
import Loading from '../Loading';
import UserType from '../../domain/entities/valueObjects/userType';
import UserProvider from '../../infra/provider/userProvider';

const Sidebar: React.FC<{ setHeaderTitle: (title: string) => void }> = ({ setHeaderTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState(new UserType(''));
  const [userName, setUserName] = useState('');
  const [profileImage, setProfileImage] = useState(User);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const handleMouseEnter = () => setIsOpen(true);
  const handleMouseLeave = () => setIsOpen(false);
  const userProvider = UserProvider.getInstance();

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  useEffect(() => {
    loadUserData();
  }, []);

  useEffect(() => {
    const handleProfileUpdate = (event: CustomEvent) => {
      const { userName: newUserName, profileImage: newProfileImage } = event.detail;
      setUserName(newUserName);
      setProfileImage(newProfileImage);
    };

    window.addEventListener('profileUpdated', handleProfileUpdate as EventListener);

    return () => {
      window.removeEventListener('profileUpdated', handleProfileUpdate as EventListener);
    };
  }, []);

  const loadUserData = async () => {
    const user = await userProvider.getCurrentUser();
    setUserName(user.name);
    setProfileImage(user.image ? user.image.toString() : '');
    setEmail(user.email);
    setUserType(new UserType(localStorage.getItem('userType') ?? ''));
  }

  const displayName = userName || (email ? email.split('@')[0] : 'Usuário');

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="container">
        <div className="logo">
          <a href="https://www.homecorp.com.br/" target="_blank" rel="noopener noreferrer">
            <img src={isOpen ? Logo : LogoSM} alt="Logo" />
          </a>

        </div>

        <ul className="menu">
          <li className={isActive('/home') ? 'active' : ''} onClick={() => { setHeaderTitle('Home'); navigate('/home'); }}>
            <Gauge size={22} className="menu-icon" />
            {isOpen && <span>Dashboard</span>}
          </li>

          <li className={isActive('/propostas') ? 'active' : ''} onClick={() => { setHeaderTitle('Propostas'); navigate('/propostas/visualizar'); }}>
            <Wallet size={22} className="menu-icon" />
            {isOpen && <span>Propostas</span>}
          </li>

          <li className={isActive('/empreendimentos') ? 'active' : ''} onClick={() => { setHeaderTitle('Empreendimentos'); navigate('/empreendimentos/visualizar'); }}>
            <Building size={22} className="menu-icon" />
            {isOpen && <span>Empreendimentos</span>}
          </li>

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/incorporadoras') || isActive('/Incorporadoras') ? 'active' : ''} onClick={() => { setHeaderTitle('Incorporadoras'); navigate('/Incorporadoras/visualizar'); }}>
              <Construction size={22} className="menu-icon" />
              {isOpen && <span>Incorporadoras</span>}
            </li>
          )}

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/usuarios') ? 'active' : ''} onClick={() => { setHeaderTitle('Usuarios'); navigate('/usuarios/visualizar'); }}>
              <UserPlus2 size={22} className="menu-icon" />
              {isOpen && <span>Usuarios</span>}
            </li>
          )}

          <li className={location.pathname === '/leads' ? 'active' : ''} onClick={() => { setHeaderTitle('Leads'); navigate('/leads'); }}>
            <UserCheck size={22} className="menu-icon" />
            {isOpen && <span>Leads</span>}
          </li>

          <li className={isActive('/leads-site') ? 'active' : ''} onClick={() => { setHeaderTitle('Leads Site'); navigate('/leads-site'); }}>
            <UserSearch size={22} className="menu-icon" />
            {isOpen && <span>Leads site</span>}
          </li>

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/outros/FAQ') ? 'active' : ''} onClick={() => { setHeaderTitle('Tópicos Frequentes'); navigate('/outros/FAQ'); }}>
              <MessageCircleQuestionIcon size={22} className="menu-icon" />
              {isOpen && <span>Tópicos frequentes (FAQ)</span>}
            </li>
          )}

          <li className={isActive('/outros/scheduling') || isActive('/outros/Scheduling') ? 'active' : ''} onClick={() => { setHeaderTitle('Agenda de visitas'); navigate('/outros/scheduling'); }}>
            <NotebookIcon size={22} className="menu-icon" />
            {isOpen && <span>Agenda de visitas</span>}
          </li>

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/outros/ViabilitySpreadsheet') ? 'active' : ''} onClick={() => { setHeaderTitle('Planilha de viabilidade'); navigate('/outros/ViabilitySpreadsheet'); }}>
              <FileSpreadsheet size={22} className="menu-icon" />
              {isOpen && <span>Planilha de viabilidade</span>}
            </li>
          )}

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/outros/DocsIncorporadores') ? 'active' : ''} onClick={() => { setHeaderTitle('Documentos de incorporadoras'); navigate('/outros/DocsIncorporadores'); }}>
              <FileChartColumn size={22} className="menu-icon" />
              {isOpen && <span>Docs de incorporadores</span>}
            </li>
          )}

          {userType.getUserType() !== userType.CORRESPONDENT && (
            <li className={isActive('/outros/DocsEnterprises') ? 'active' : ''} onClick={() => { setHeaderTitle('Documentos de empreendimentos'); navigate('/outros/DocsEnterprises'); }}>
              <FileChartColumnIncreasing size={22} className="menu-icon" />
              {isOpen && <span>Docs de empreendimentos</span>}
            </li>
          )}

          {/* Etapas da construção - sempre por último */}
          <li className={isActive('/outros/ConstructionSteps') ? 'active' : ''} onClick={() => { setHeaderTitle('Etapas da construção'); navigate('/outros/ConstructionSteps'); }}>
            <PencilRuler size={22} className="menu-icon" style={{ opacity: 1 }} />
            {isOpen && (
              <>
                <span>Etapas da construção</span>
              </>
            )}
          </li>
        </ul>
      </div>

      <div className={`user-info ${isActive('/perfil') ? 'active' : ''}`} onClick={() => { setHeaderTitle('Editar Perfil'); navigate('/perfil/editar'); }}>
        <img src={profileImage} alt="User" />
        <div className="user-details">
          <span>{displayName}</span>
          <span>{email}</span>
          <span className="user-type-small">{userType.getFormatted()}</span>
        </div>
      </div>

      <ul className="menu logout">
        <li onClick={AxiosHttp.logout}>
          <LogOut size={22} className="menu-icon-out" />
          {isOpen && <span>Sair</span>}
        </li>
      </ul>

    </div>


  );
};

export default Sidebar;
